
import { getViewport } from '@/helpers/ui-helper';
import Vue from 'vue';
import { Component, Prop, Ref } from 'vue-property-decorator';
import CustomIonInfiniteScroll from './CustomIonInfiniteScroll.vue';

@Component({
	name: 'InfiniteScroll',
	components: {
		CustomIonInfiniteScroll,
	},
})
export default class InfiniteScroll extends Vue {
	@Prop({ default: false }) disabled: boolean;
	@Prop({ default: false }) loading: boolean;
	@Prop({ default: false }) hideSpinner: boolean;

	@Ref('infiniteScroll') readonly infiniteScroll: CustomIonInfiniteScroll;

	get viewport(): string {
		return getViewport();
	}

	get thresholdValue(): string {
		// this is to prevent sluggish infinite scroll triggers
		let value = '80%';
		switch (this.viewport) {
			case 'tablet':
				value = '150%';
				break;
			case 'smartphone':
				value = '260%';
				break;
		}
		return value;
	}

	// reset manually triggers an infinite scroll recomputation, without having to wait for a scroll event.

	// It should be called after each manually fetched first pages (e.g. in a parent stateful component "mounted" hook)
	// to ensure that the content from the first page is actually fitting our threshold criteria, even
	// before the user starts scrolling.

	// In real life, calling it is not mandatory if the first page is 100% sure to be large enough to meet
	// our threshold (e.g. popular view).
	reset() {
		this.infiniteScroll.reset();
		this.infiniteScroll.refresh();
	}
}
